import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class SearchtoolboxService {

  constructor(private http: HttpClient) { }
  public grabcandidate: Subject<any> = new Subject(); 

  getAutoCompleteDataList(data){
    var url = devUrl + "/searchtoolbox/autocomplete_dropdown_data"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Related Data ', url)));
  }

  recommendedData(data){
    var url = devUrl + "/searchtoolbox/related_data"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Related Data ', url)));
  }

  createBooleanSearch(data){
    var url = devUrl + "/searchtoolbox/generate_boolean_strings_and_search_queries"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Create Boolean search', url)));
  }

  googleSearchApi(data){
    var url = devUrl + "/searchtoolbox/custom_search_results"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Custom search Url', url)));
  }

  savePlatFormDetails(data){
    var url = devUrl + "/searchtoolbox/save_accessed_platform";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Save Access Platform', url)));
  }


  fetchsearchtoolboxhistory(data){
    var url = devUrl + "/searchtoolbox/fetchsearchtoolboxhistory";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Save Access Platform', url)));
  }

  linkedInSearch(data){
    var url = devUrl + "/searchtoolbox/linkedinsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('LinkedIn Search: ', url)));
  }

  xingSearch(data){
    var url = devUrl + "/searchtoolbox/xingsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Xing Search: ', url)));
  }

  quoraSearch(data){
    var url = devUrl + "/searchtoolbox/quorasearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Quora Search: ', url)));
  }

  twitterSearch(data){
    var url = devUrl + "/searchtoolbox/twittersearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Twitter Search: ', url)));
  }

  angelListSearch(data){
    var url = devUrl + "/searchtoolbox/angellistsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('AngelList Search: ', url)));
  }

  kaggleSearch(data){
    var url = devUrl + "/searchtoolbox/kagglesearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Kaggle Search: ', url)));
  }

  githubSearch(data){
    var url = devUrl + "/searchtoolbox/githubsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('GitHub Search: ', url)));
  }

  stackOverflowSearch(data){
    var url = devUrl + "/searchtoolbox/stackoverflowsearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Stack Overflow Search: ', url)));
  }

  behanceSearch(data){
    var url = devUrl + "/searchtoolbox/behancesearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Behance Search: ', url)));
  }

  dribbbleSearch(data){
    var url = devUrl + "/searchtoolbox/dribbblesearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Dribbble Search: ', url)));
  }

  doximitySearch(data){
    var url = devUrl + "/searchtoolbox/doximitysearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Doximity Search: ', url)));
  }

  healthProfsSearch(data){
    var url = devUrl + "/searchtoolbox/healthprofssearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('HealthProfs Search: ', url)));
  }

  researchGateSearch(data){
    var url = devUrl + "/searchtoolbox/researchgatesearch";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('ResearchGate Search: ', url)));
  }

  parseJobDescription(data){
    var url = devUrl + "/searchtoolbox/parsejobdescription";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Parse Job Description: ', url)));
  }

  /**
   * @deprecated
   * Not in use it is replaced by `jdParser`
   * @param description 
   * @returns 
   */
  jdJSONDetails(description = null) {
    const formData = new FormData();
    formData.append("description", description);
    const url = devUrl + "/openai/jobdescription";
    return this.http.post(url, formData).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Fetch JSON params for Job Description: ', url)));
  }

  jdParser(description = null) {
    const formData = new FormData();
    formData.append("description", description);
    const url = devUrl + "/personsearch/jobdescription";
    return this.http.post(url, formData).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Fetch JSON params for Job Description: ', url)));
  }

  documentToText(file) {
    const formData = new FormData();
    formData.append("document", file);
    const url = devUrl + "/extracttext";
    return this.http.post(url, formData).pipe(map(response => { return response; } ),
    catchError(GlobalService.handleError('Extract text form document', url)));
  }
  
  bulkgrab(data){
    var url = devUrl + "/candidate/bulkgrab";
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('bulkgrab', url)));
  }

  bulkextractionstatus(){
    var url = devUrl + '/candidate/bulkextractionstatus' 
    return this.http.get(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('bulkextractionstatus', url)))
  }

  public passGrabCandidateData (data): void {
    this.grabcandidate.next(data);
  }
  
  public getGrabCandidateData (): Observable<any> {
    return this.grabcandidate.asObservable();
  }


  getmappings(){
    var url = devUrl + "/searchtoolbox/mappings";
    return this.http.get(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('bulkextractionstatus', url)))
}

searchviaboolean(data){
      var url = devUrl + "/searchtoolbox/searchviaboolean";
      return this.http.post(url, data).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('searchviaboolean', url)));
    }

    enrichcseresults(data){
      var url = devUrl + "/searchtoolbox/enrichcseresults";
      return this.http.post(url, data).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('enrichcseresults', url)));
    }

    bulkcandidatereachout(data){
      var url = devUrl + "/searchtoolbox/bulkcandidatereachout";
      return this.http.post(url, data).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('enrichcseresults', url)));
    }

    storemailsendingactivity(data){
      var url = devUrl + "/searchtoolbox/storemailsendingactivity";
      return this.http.post(url, data).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('storemailsendingactivity', url)));
    }
}
  
